"use client";

import { BSRCaution } from "./bsr/BSRCaution";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Caution as LegacyCaution } from "./legacy/Caution";

export const Caution = createBSRExperimentIcon(LegacyCaution, BSRCaution);
